import { render, staticRenderFns } from "./AppHeaderDocumentationMenu.vue?vue&type=template&id=ea56e102&lang=pug"
import script from "./AppHeaderDocumentationMenu.vue?vue&type=script&lang=js"
export * from "./AppHeaderDocumentationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports